export default __webpack_public_path__ + "static/media/beforeAccess.10c142b5.png";